export default {
  LIST_ERROR_ADD: 'LIST_ERROR_ADD',
  LIST_ERROR_REMOVE: 'LIST_ERROR_REMOVE',
};


// WEBPACK FOOTER //
// ./modules/list/constants/ErrorConstants.js